import Marquee from "react-fast-marquee";
import { brandLogos } from "../../assets/dummyData";
import { Box } from "@mui/material";

const BrandLogoSlider = () => {
  return (
    <Box sx={{ my: 0 }}>
      <Marquee gradient={false} speed={50} pauseOnHover={true} direction="left">
        {brandLogos.map((logo, i) => (
          <Box key={i} sx={{ mx: 2, display: "inline-block" }}>
            <img
              src={logo}
              alt="brand"
              style={{ width: "120px", height: "60px", objectFit: "contain" }}
            />
          </Box>
        ))}
      </Marquee>
    </Box>
  );
};

export default BrandLogoSlider;
